import { createRouter, createWebHistory } from 'vue-router';
import LandingLayout from '@/layout/LandingLayout.vue';
import appRoutes from '@/router/appRoutes';
import { useUiVersion } from '@/stores/useUiVersion';
import { usePartnerRefStore } from '@/stores/partnerRefStore';
import useCapabilities from '@/composables/useCapabilities';
import useToaster from '@/composables/useToaster';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'landing',
      component: () => import('@/views/LandingView.vue'),
      meta: {
        layout: LandingLayout
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/pages/auth/Login.vue'),
      meta: {
        layout: LandingLayout
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/pages/auth/CreateAccount.vue'),
      meta: {
        layout: LandingLayout
      }
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import('@/views/PrivacyPolicy.vue'),
      meta: {
        layout: LandingLayout
      }
    },
    {
      path: '/terms-of-service',
      name: 'terms-of-service',
      component: () => import('@/views/TermsOfService.vue'),
      meta: {
        layout: LandingLayout
      }
    },
    {
      component: () => import('@/views/pages/NotFound.vue'),
      meta: {
        layout: LandingLayout
      },

      path: '/:pathMatch(.*)*',
      name: 'NotFound'
    },

    {
      path: '/portfolios/:path',
      name: 'portfolio',
      component: () => import('@/views/PublicPortfolioView.vue'),
      meta: {
        layout: LandingLayout
      }
    },
    appRoutes
  ]
});

// Hard-guard v2-only routes: v1 users are redirected back to the logs list
// (re-opening the v1 modal flow for creation when possible).
router.beforeEach((to) => {
  if (to.query.ref) {
    usePartnerRefStore().capture(String(to.query.ref));
  }

  const capability = to.meta?.capability;

  if (capability) {
    const capabilities = useCapabilities();

    if (!capabilities.has(capability)) {
      useToaster().warn({
        summary: 'Plan upgrade required',
        detail: 'Your current plan does not include this feature.'
      });

      return { name: 'my-logs' };
    }
  }

  if (!to.meta?.requiresV2) {
    return true;
  }

  const uiVersion = useUiVersion();

  if (uiVersion.isV2) {
    return true;
  }

  if (to.name === 'my-logs-new') {
    return { name: 'my-logs', query: { n: to.query.type || 'standard' } };
  }

  return { name: 'my-logs' };
});

export default router;
